module.exports = __webpack_public_path__ + "static/media/gamevict.4c75442c.png";